import { render, staticRenderFns } from "./UserCenterSelect.vue?vue&type=template&id=3efaad82&scoped=true"
import script from "./UserCenterSelect.vue?vue&type=script&lang=js"
export * from "./UserCenterSelect.vue?vue&type=script&lang=js"
import style0 from "./UserCenterSelect.vue?vue&type=style&index=0&id=3efaad82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efaad82",
  null
  
)

export default component.exports